(() => {
  const mq = window.matchMedia('(max-width: 789px)');

  const menus = () => document.querySelectorAll('[data-store-footer-menu]');

  const sync = () => {
    const collapsed = mq.matches;
    for (const menu of menus()) {
      menu.open = !collapsed;
      const summary = menu.querySelector('summary');
      if (summary instanceof HTMLElement) {
        if (collapsed) {
          summary.removeAttribute('tabindex');
        } else {
          summary.tabIndex = -1;
        }
      }
    }
  };

  const bindKlaviyo = (root = document) => {
    const mount = root.querySelector('[data-store-footer-klaviyo]');
    const fallback = root.querySelector('[data-store-footer-signup]');
    if (!(mount instanceof HTMLElement) || !(fallback instanceof HTMLElement)) return;

    const swap = () => {
      fallback.hidden = Boolean(mount.querySelector('form'));
    };

    swap();
    const observer = new MutationObserver(swap);
    observer.observe(mount, { childList: true, subtree: true });
  };

  sync();
  bindKlaviyo();
  mq.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector?.('[data-store-footer-menu]')) sync();
    if (event.target.querySelector?.('[data-store-footer-klaviyo]')) bindKlaviyo(event.target);
  });
})();
